import { useFeatureFlag } from '@artic/ui/feature-flag';
import { createFileRoute, Link } from '@tanstack/react-router';

import { BillOfOperationsWorkspace } from '../../features/bill-of-operations/bill-of-operations-workspace';

export const Route = createFileRoute('/bill_of_operations/')({
  staticData: {
    breadcrumb: 'Bill of Operations',
    layout: 'full-height',
  },
  component: BillOfOperationsPage,
});

function BillOfOperationsPage() {
  const plannerEnabled = useFeatureFlag('planner');

  if (!plannerEnabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature Not Available</h2>
        <p className="text-muted-foreground text-sm">
          The Bill of Operations editor is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return (
    <BillOfOperationsWorkspace
      renderProductLabel={(product) => {
        const showKeySubheading = product.product_key !== product.product_name;
        return (
          <Link
            to="/products/$productId"
            params={{ productId: product.product_id }}
            className="flex min-w-0 flex-col leading-tight hover:underline focus-visible:underline"
            title={product.product_name}
          >
            <span className="truncate text-sm font-medium">{product.product_name}</span>
            {showKeySubheading && (
              <span className="text-muted-foreground truncate font-mono text-[10px]">
                {product.product_key}
              </span>
            )}
          </Link>
        );
      }}
    />
  );
}
